import { EditorProvider } from '@/components/elements/Editor/EditorProvider'
import { RouteContainer } from '@/components/elements/Layouts/RouteContainer'
import { Divider } from '@/components/ui/Divider/Divider'
import { Kind } from '@/constants/kinds'
import { createMediaFeedModule } from '@/hooks/modules/createMediaFeedModule'
import { useMediaFeedState } from '@/hooks/state/useMediaFeed'
import { useCurrentPubkey } from '@/hooks/useAuth'
import { useResetScroll } from '@/hooks/useResetScroll'
import { useMemo } from 'react'
import { MediaFeed } from './MediaFeed'
import { MediaHeader } from './MediaHeader'

export const MediaRoute = () => {
  useResetScroll()
  const pubkey = useCurrentPubkey()
  const module = useMemo(() => createMediaFeedModule(pubkey), [pubkey])
  const feed = useMediaFeedState(module)
  return (
    <RouteContainer header={<MediaHeader feed={feed} />}>
      <EditorProvider kind={Kind.Media} queryKey={feed.queryKey} initialOpen={false} />
      <Divider />
      <MediaFeed feed={feed} />
    </RouteContainer>
  )
}
